import { Box, Spacer } from '@jfs/ui-new'
import { StackActions, useNavigation, useRoute } from '@react-navigation/core'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { AadhaarCardStatusModel } from '../../comps/AadhaarLinkStatusModel'
import { AepsButton } from '../../comps/AepsButton'
import { AepsCheckBox } from '../../comps/AepsCheckBox'
import { Container } from '../../comps/Container'
import { DeleteBeneficiaryOtp } from '../../comps/OtpTextInputWithTimer/DeleteOtpWithTimer'
import { ProgressDialog } from '../../comps/ProgressDialog'
import { RowItem } from '../../comps/RowItem'
import { ScanUserAuth } from '../../comps/ScanUserAuth'
import { Title } from '../../comps/Title'
import { RootStore, useLazyApiData, useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'
import { nativeJSComm, nativeJSMapper } from '../../util/WebFns'
import {
  getFingerPrintData,
  getFormattedAmount,
  getMaskedAadhaarNumber,
  getMaskedMobileNumber,
  getMaskedVIDNumber,
  JIO_PAYMENT_BANK_BIN,
  parseBioMetricDeviceInfo,
  pkceBase64URLEncodeValue
} from '../../util/utill'

export const ReviewCashWithdrawalScreen = React.memo(() => {
  const navigation = useNavigation()
  const [checked, setChecked] = useState(false)
  const [postOtpChecked, setPostOtpChecked] = useState(false)
  const [shouldShowFingerPrintModel, setShouldShowFingerPrintModel] = React.useState(false)
  const [fingerPrintError, setFingerPrintError] = React.useState({ code: '', error: '', title: '' })
  const [aadhaarCardStatusInfoModel, setAadhaarCardInfoModel] = React.useState({ show: false, type: 'NOT_LINKED' })
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  //const [authMode, setAuthMode] = useState<'FACE' | 'FINGER_PRINT'>('FINGER_PRINT')
  const authModeRef = React.useRef(null)
  const OTP_THRESHOLD = 5000;

  // const { sendOtp } = useStores((store) => ({
  //   sendOtp: store.moneyTransferSession.sendOtp,
  // }))

  const { getConsentDetails, cashWithdrawalOrDepositApi, getBankId, setBioMetricDeviceInfo, sendEventAsync, generateOtpApi, getHighValueAmount, sendOtp } =
    useStores((root) => ({
      getConsentDetails: root.consents.getConsentDetails,
      cashWithdrawalOrDepositApi: root.customer.cashWithdrawalOrDepositApi,
      setBioMetricDeviceInfo: root.agent.setBioMetricDeviceInfo,
      getBankId: root.banks.getBankId,
      sendEventAsync: root.agent.session.sendEventAsync,
      generateOtpApi: root.agent.generateOtpApi,
      getHighValueAmount: root.banks.getHighValueAmount,
      sendOtp: root.moneyTransferSession.CWsendOtp,
    }))

  const route: any = useRoute()
  const staticData = CONFIGURATION[route.params.type]
  const activityType = route?.params?.activityType
  const consentDetails = getConsentDetails(activityType)
  const selectedBankId = getBankId(route.params.bankName, route?.params?.activityType);

  const [lazycashWithdrawalApi, cashWithdrawalApiHandler] = useLazyApiData(cashWithdrawalOrDepositApi)
  const [lazyGenerateOtpApi, generateOtpApiHandler] = useLazyApiData(sendOtp as any)

  useEffect(() => {
    navigation.setOptions({ headerTitle: staticData.headerTitle })
  }, [navigation, staticData.headerTitle])

  const amount = Number(route.params.amount);
  const currentBankThreshold = getHighValueAmount(route.params.bankName, route?.params?.activityType);
  const isHighValueTransaction = currentBankThreshold > 0 && amount >= currentBankThreshold;
  console.log(currentBankThreshold, amount, isHighValueTransaction, "isHighValueTransaction::")

  const getOtpConfig = () => {
    const isJioBank = selectedBankId === JIO_PAYMENT_BANK_BIN;
    const encodedConsent = consentDetails?.text1
    console.log("==> SCREEN LAYER: raw consentDetails data:", consentDetails);
    return {
      mode: isJioBank ? 54 : 56,
      purpose: 38,
      scope: isJioBank ? 'REQUEST' : 'REQUEST',
      generate: 'generate',
      entityType: isJioBank ? 1 : 2,
      amount: route.params.amount,
      aadhaarNo: route.params.aadhaarNo,
      vid: route.params.vid,
      consent: pkceBase64URLEncodeValue(encodedConsent),
      consentCode: consentDetails?.consentTextCode,
      userId: RootStore?.agent?.agentInfo?.agentUserLoginId,
      ...(!isJioBank && { bankId: selectedBankId }),
    };
  };

  console.log(consentDetails?.consentCode, "consentkeyy:::::")

  // const getOtpConfig = () => {
  //   const isJioBank = selectedBankId === JIO_PAYMENT_BANK_BIN;
  //   return {
  //     mode: isJioBank ? 54 : 56,
  //     purpose: 38
  //   };
  // };

  useEffect(() => {
    if (generateOtpApiHandler.state === 'fulfilled') {
      if (generateOtpApiHandler.data?.otpReferenceId) {
        console.log("==> SUCCESS! Captured Token from Handler State:", generateOtpApiHandler.data.otpReferenceId);
        RootStore.agent.updateOtpReferenceId(generateOtpApiHandler.data.otpReferenceId);
      }
      setIsOtpSent(true);
    } else if (generateOtpApiHandler.state === 'rejected') {
      setIsOtpSent(false);
      console.error("OTP generation failed due to a server-side error (500).");
    }
  }, [generateOtpApiHandler.state, generateOtpApiHandler.data]);

  const handleGetOtp = () => {
    const config = getOtpConfig();
    if (route.params.mobileNo) {
      // Replaced lazyGenerateOtpApi() with lazySendOtp using dynamic configurations
      lazyGenerateOtpApi(route.params.mobileNo, config)
      // if (response?.otpReferenceId) {
      //   console.log("==> FOUND ID, SAVING TO STORE:", response.otpReferenceId);
      //   RootStore.agent.updateOtpReferenceId(response.otpReferenceId);
      // }
      // setIsOtpSent(true);
    } else {
      console.log("Mobile number unavailable in route payload context.");
    }
  };

  // const handleGetOtp = () => {
  //   lazyGenerateOtpApi();
  //   setIsOtpSent(true);
  // };

  const onVerifyAndProceed = async (enteredOtp: string) => {
    setIsVerifyingOtp(true);
    try {
      setOtp(enteredOtp);
      setIsOtpVerified(true);
      setIsOtpSent(false);
      setIsOtpSent(false);
    } catch (e) {
      console.error("OTP Verification failed");
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  // const onVerifyAndProceed = async (enteredOtp: string) => {
  //   setIsVerifyingOtp(true);
  //   try {
  //     setIsOtpVerified(true);
  //     setIsOtpSent(false);
  //   } catch (e) {
  //     console.error("OTP Verification failed");
  //   } finally {
  //     setIsVerifyingOtp(false);
  //   }
  // };

  useEffect(() => {
    if (cashWithdrawalApiHandler.state === 'fulfilled') {
      const showRetry = cashWithdrawalApiHandler?.data?.responseCode !== 'WL'

      navigation.goBack()
      navigation.dispatch(
        StackActions.replace(
          Screens.CASH_WITHDRAWAL_STATUS as never,
          { ...route.params, consentDetails, showRetry, currentBankThreshold, noOfRetry: route.params?.noOfRetry } as never,
        ),
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cashWithdrawalApiHandler])

  useEffect(() => {
    if (
      cashWithdrawalApiHandler.state === 'rejected' &&
      cashWithdrawalApiHandler?.data?.data?.responseCode === '22413'
    ) {
      !aadhaarCardStatusInfoModel.show && setAadhaarCardInfoModel({ show: true, type: 'NOT_LINKED' })
    }
  }, [aadhaarCardStatusInfoModel.show, cashWithdrawalApiHandler, cashWithdrawalApiHandler.state])

  const onScanSuccess = (sucess: any) => {
    getFingerPrintData(sucess, consentDetails?.text1, authModeRef.current).then((fingerprintData: any) => {
      setShouldShowFingerPrintModel(false)
      setBioMetricDeviceInfo(parseBioMetricDeviceInfo(fingerprintData))
      sendEventAsync({
        status: 'FINGERPRINT_CAPTURED',
        biometricDeviceInfo: RootStore.agent.deviceInfo.biometricDeviceInfo,
      })
      lazycashWithdrawalApi(
        route.params.aadhaarNo,
        fingerprintData,
        getBankId(route.params.bankName, route?.params?.activityType),
        route.params.bankName,
        route.params.mobileNo,
        route.params.amount,
        route.params.vid,
        consentDetails,
        route.params.type,
        route.params?.authorizationCode,
        authModeRef?.current,
        otp
      )
    })
  }

  const onScanError = (error: any) => {
    sendEventAsync({
      status: 'FINGERPRINT_ERROR',
      errorDescription: error,
    })
    setFingerPrintError(JSON.parse(error))
  }

  const onPress = (authMode: 'FACE' | 'FINGER_PRINT') => {
    setFingerPrintError({ code: '', error: '', title: '' })
    authModeRef.current = authMode
    if (window?.AepsWebViewInterface) {
      setShouldShowFingerPrintModel(true)
      nativeJSComm(nativeJSMapper.scanFingerPrint, onScanSuccess, onScanError, { authMode, authOtp: otp })
    } else {
      lazycashWithdrawalApi(
        route.params.aadhaarNo,
        otp,
        '',
        getBankId(route.params.bankName, route?.params?.activityType),
        route.params.bankName,
        route.params.mobileNo,
        route.params.amount,
        route.params.vid,
        consentDetails,
        route.params.type,
        route.params?.authorizationCode,
        authMode,
      )
    }
  }

  const goBackToHomeScreen = () => {
    setAadhaarCardInfoModel({ show: false, type: 'NOT_LINKED' })
    navigation.canGoBack() && navigation.goBack()
    navigation.canGoBack() && navigation.goBack()
  }

  const onAadhaarCardLinked = () => {
    setAadhaarCardInfoModel({ show: true, type: 'LINKED' })
  }

  const onPrimaryButtonClick = () => {
    setAadhaarCardInfoModel({ show: false, type: 'NOT_LINKED' })
    if (aadhaarCardStatusInfoModel.type == 'NOT_LINKED') {
      navigation.navigate(Screens.ENTER_CUSTOMER_MOBILE as never, { ...route?.params, onAadhaarCardLinked } as never)
    } else {
      onPress(authModeRef?.current)
    }
  }

  return (
    <Container showFooter={true} showBrandLogo={true}>
      <Box f={1} overflow={'scroll'}>
        <Title title={staticData.title} />
        <Spacer size={32} />
        {route.params.aadhaarNo && (
          <RowItem heading={'Payee’s Aadhar'} detail={getMaskedAadhaarNumber(route.params.aadhaarNo)} />
        )}
        {route.params.vid && <RowItem heading={'Payee’s VID'} detail={getMaskedVIDNumber(route.params.vid)} />}
        <Spacer size={8} />
        <RowItem heading={'Customer’s Bank Name'} detail={route.params.bankName} />
        <Spacer size={8} />
        {route.params.mobileNo && (
          <>
            <RowItem heading={'Mobile'} detail={getMaskedMobileNumber(route.params.mobileNo)} />
            <Spacer size={8} />
          </>
        )}
        <RowItem heading={staticData.rowItemAmountHeading} detail={getFormattedAmount(route.params.amount)} />
        <Spacer size={18} />



        <Box borderStyle={'dashed'} borderTopWidth={1} width={'100%'} borderColor={'PRIMARY_GREY'} />
        <Spacer size={16} />
        {isHighValueTransaction && !isOtpSent && !isOtpVerified && (
          <AepsCheckBox
            text="I hereby provide my explicit consent to trigger an OTP validation for this Aadhaar transaction."
            checked={checked}
            onChange={(isChecked: boolean) => setChecked(isChecked)}
          />
        )}
        {isHighValueTransaction && isOtpSent && (
          <>
            <DeleteBeneficiaryOtp
              mobileNumber={route.params.mobileNo}
              value={otp}
              onChangeText={setOtp}
              onOtpComplete={onVerifyAndProceed}
              onResendOtpButtonPress={handleGetOtp}
              isModalOpen={true}
              countdownTime={route.params.type === 'cash_withdrawal' ? 180 : 30}
            />
            <Spacer size={16} />
          </>
        )}
        {(!isHighValueTransaction || isOtpSent) && (
          <AepsCheckBox
            text={consentDetails?.text1}
            checked={postOtpChecked}
            onChange={(isChecked: boolean) => setPostOtpChecked(isChecked)}
          />
        )}
      </Box>

      {isHighValueTransaction && !isOtpSent && !isOtpVerified ? (
        <AepsButton
          title="Get OTP"
          onPress={handleGetOtp}
          disabled={!checked}
          isLoading={generateOtpApiHandler.state === 'pending'}
        />
      ) : (
        <ScanUserAuth
          onPress={onPress}
          isLoading={cashWithdrawalApiHandler.state === 'pending'}
          // Uses the new postOtpChecked state for fingerprint authorization
          // disabled={!postOtpChecked || (isHighValueTransaction && otp.length < 6)}
          disabled={
            isHighValueTransaction
              ? (!postOtpChecked || otp.length < 6)
              : !postOtpChecked
          }
          allowedModes={route.params.type === 'cash_withdrawal' ? ['FINGER_PRINT'] : ['FINGER_PRINT', 'FACE']}
        />
      )}

      <ProgressDialog
        error={fingerPrintError}
        onRetry={onPress}
        show={shouldShowFingerPrintModel || cashWithdrawalApiHandler.state === 'pending'}
        type={fingerPrintError.code ? 'error' : cashWithdrawalApiHandler.state === 'pending' ? 'loader' : authModeRef.current === "FACE" ?
          'face' :
          'fingerprint'}
        onCancel={() => {
          setShouldShowFingerPrintModel(false)
          setFingerPrintError({ code: '', error: '', title: '' })
        }}
      />
      <AadhaarCardStatusModel
        status={aadhaarCardStatusInfoModel.type as any}
        show={aadhaarCardStatusInfoModel.show}
        onPrimaryButtonPress={onPrimaryButtonClick}
        onSecondaryButtonPress={goBackToHomeScreen}
      />
    </Container>
  )
})
const CONFIGURATION: any = {
  cash_withdrawal: {
    headerTitle: 'Cash Withdrawal',
    title: 'Review Transaction Details',
    rowItemAmountHeading: 'Withdrawal amount',
  },
  cash_deposit: {
    headerTitle: 'Cash Deposit',
    title: 'Review Transaction Details',
    rowItemAmountHeading: 'Amount to Deposit',
  },
}
